import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Menu from "../../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../../Navigation/Menu";
import { Puff } from "react-loading-icons";
import EventTablesRequest from "../EventTablesRequest";
import Table from "../../../../Layout/Table/Table";
import { Grid, EstadoCellRenderer } from "../../../../Layout/Grid/GridView";
import NavBar from "../../../../../components/NavBar";

const ReservationList = () => {
  let params = useParams();
  const gridRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    reservations: [],
    event: {
      id: 0,
      name: "",
      id_venues: "",
    },
  });

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#f92056" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const getListReservations = async () => {
    setIsLoading(true);
    let info = await EventTablesRequest.getListReservationsEvent({
      id_events: params.id,
    });
    if (info && info.status) {
      setState(info.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getListReservations();
  }, []);

  const columns = [
    "Data Reserva",
    "Mesa",
    "Preço",
    "Cliente",
    "Telefone Cliente",
    "Contribuinte Cliente",
    "Data Checkout",
    "Estado",
  ];

  const StatusColumn = ({ status, label }) => {
    return (
      <div className={`status-column ${status.toString().toLowerCase()}`}>
        {label}
      </div>
    );
  };

  const serializeRowsColums = () => {
    return state.reservations.map((item) => {
      return {
        ...item,
        Estado: <StatusColumn status={item.status} label={item.Estado} />,
      };
    });
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-xs-12 col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-12">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/events/">Eventos</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={`/my/events/${params.id}/tables`}>
                            Gestor de Mesas
                          </Link>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Lista de reservas
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-8">
                    <h2 className="dashboard-h2">
                      Evento: {state.event.name}{" "}
                      <small style={{ color: "#ea2c61" }}>|</small>{" "}
                      <small style={{ fontWeight: "100" }}>
                        {state.event.date_formated}
                      </small>
                    </h2>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-12">
                    {/* <Table
                                            columns={columns}
                                            data={serializeRowsColums(state.reservations)}
                                            currentPage={1}
                                            itemsPerPage={1000}
                                            totalItems={state.reservations.length}
                                        /> */}
                    {/* const columns = ['Data Reserva', 'Mesa', 'Preço', 'Cliente', 'Telefone Cliente', 'Contribuinte Cliente', 'Data Checkout', 'Estado']; */}
                    <Grid
                      ref={gridRef}
                      rows={state.reservations}
                      cols={[
                        { hide: true, field: "id" },
                        { headerName: "Data", field: "date_reservation" },
                        { headerName: "Mesa", field: "name" },
                        {
                          headerName: "Valor",
                          field: "price",
                          cellStyle: { textAlign: "right" },
                        },
                        { headerName: "Cliente", field: "owner_name" },
                        {
                          headerName: "Telemóvel",
                          field: "owner_phone_number",
                        },
                        {
                          headerName: "Contribuinte",
                          field: "owner_vat_number",
                        },
                        {
                          headerName: "Data Checkout",
                          field: "datetime_checkout",
                        },
                        {
                          headerName: "Estado",
                          field: "status",
                          cellRenderer: EstadoCellRenderer,
                        },
                      ]}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default ReservationList;
